import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { TableLazyLoadEvent, TableModule, TableRowSelectEvent } from 'primeng/table';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { LogEntry } from '../log.model';
import { LogService } from '../log.service';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';

@Component({
  selector: 'app-log-result',
  imports: [
    DatePipe,
    DecimalPipe,
    SharedModule,
    TableRowDirective,
    TableModule,
    KeepScrollPositionDirective
  ],
  templateUrl: './log-result.component.html',
  styleUrl: './log-result.component.css',
})
export class LogResultComponent {
  logService = inject(LogService);
  data = this.logService.datasource.data;

  rowClass(item: LogEntry) {
    if (item.fejlet) {
      return '!text-lpred';
    }
    return null;
  }

  onRowSelect(e: TableRowSelectEvent) {
    this.logService.selectLogResultRow(e.data);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.logService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }
}
